module.exports = __webpack_public_path__ + "media/images/lb/988-18bec6942c57087e68250613ab0fc361.svg";